import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputDate from '@/components/inputs/InputDate/InputDate.vue';
import { WatchOptions } from 'vue';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';

@Component({
  components: {
    InputText,
    InputDate,
  },
})
export default class QuestionnaireIdentity extends Vue {
  @Prop() public value!: QuestionnaireDTO;
  @Prop({ default: false }) public updating?: boolean;
  public error: boolean = false;
  private errorMessage?: string = undefined;
  private questionnaire: QuestionnaireDTO = {} as QuestionnaireDTO;

  public onConfirmChange() {
    const updatedValue = JSON.parse(JSON.stringify(this.questionnaire));
    this.$emit('input', updatedValue);
    this.$emit('updating', false);
  }

  public onCancel() {
    this.questionnaire = JSON.parse(JSON.stringify(this.value));
    this.error = false;
    this.$emit('updating', false);
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: QuestionnaireDTO, oldValue: QuestionnaireDTO) {
    if (oldValue !== value) {
      this.questionnaire = JSON.parse(JSON.stringify(this.value));
    }
  }
}
